import React, { useState, useEffect, useRef } from 'react';

import { getDocs } from "firebase/firestore";
import { firestore } from "../firebase/firebase";
import 'firebase/compat/firestore';

import { Card, ProgressBar, Button, Spinner, Row, Col, Modal, Offcanvas } from "react-bootstrap";

import { motion } from 'framer-motion';

import axios from "axios";

import { useHistory } from "react-router-dom";

import {  Link } from "react-router-dom";

import Footer from "../organisation/footer/Footer";

import { AiFillAudio } from "react-icons/ai";

import logo from "../images/logo.svg"

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


const storageLanguageExtra =localStorage.getItem("language");



const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition
    const mic = new SpeechRecognition()
    
    mic.continuous = true
    mic.interimResults = true
    mic.lang = `${storageLanguageExtra}`;


    //navigator.getUserMedia({audio: true});
    //navigator.mediaDevices.getUserMedia({audio:true});

    const conversation = [];


const ListedQuestion = () => {

    //middleware

    const history = useHistory();

    const storageLevel = localStorage.getItem("level");
    const storageLanguage =localStorage.getItem("language");
    //const messagesRef = firestore.collection(`levels/${storageLevel}/questions`);
    const messagesRef = firestore.collection(`levels/${storageLevel}/questions`)
    const [users, setUsers] = useState([]);
    const [question, setQuestion] = useState([]);
    const [loading, setLoading] = useState(false);
    const [displaySpinner, setDisplaySpinner] = useState(false);

    const [questionKey, setQuestionKey] = useState(1);
    const [isListening, setIsListening] = useState(false);
    
    const [note, setNote] = useState('');

    const [lives, SetLives] = useState(3);

    const [success, setSuccess] = useState(null);

    const [transcriptDisplay, setTranscriptDisplay] = useState('Click and hold one of the below to attempt to respond.');
 
    const [disabledOne] = useState(false);
    const [disabledTwo] = useState(false);
    const [disabledThree] = useState(false);

    const [translatedOne, setTranslatedOne] = useState();
    const [translatedTwo, setTranslatedTwo] = useState();
    const [translatedThree, setTranslatedThree] = useState();
    const [translatedQuestion, setTranslatedQuestion] = useState(); 

    const [phasedInput, setPhasedInput] = useState(); 
    const [MainQuestionSwitch, setMainQuestionSwitch] = useState(false); 

    const [diplayTranslationOne, setDiplayTranslationOne] = useState(false);
    const [diplaySpeechButtonOne, setDiplaySpeechButtonOne] = useState(false);
    const [diplayTranslationTwo, setDiplayTranslationTwo] = useState(false);
    const [diplaySpeechButtonTwo, setDiplaySpeechButtonTwo] = useState(false);
    const [diplayTranslationThree, setDiplayTranslationThree] = useState(false);
    const [diplaySpeechButtonThree, setDiplaySpeechButtonThree] = useState(false);

      const [timeLeft, setTimeLeft] = useState(100);


    const [originalOne, setOriginalOne] = useState();
    const [originalTwo, setOriginalTwo] = useState();
    const [originalThree, setOriginalThree] = useState();
    const [originalQuestion, setOriginalQuestion] = useState();


    const [originalOneNextQuestion, setOriginalOneNextQuestion] = useState();
    const [originalTwoNextQuestion, setOriginalTwoNextQuestion] = useState();
    const [originalThreeNextQuestion, setOriginalThreeNextQuestion] = useState();



    const [showOne, setShowOne] = useState(false);
    const [showTwo, setShowTwo] = useState(false);

    const handleShowOne = () => setShowOne(true);
    const handleShowTwo = () => setShowTwo(true);

    const [showTab, setShowTab] = useState(false);
      
    const handleCloseTab = () => setShowTab(false);
    const handleShowTab = () => setShowTab(true);


    const [questionMatchBoolan, setQuestionMatchBoolan] = useState(false);

    const [questionMatchOne, setQuestionMatchOne] = useState();
    const [questionMatchTwo, setQuestionMatchTwo] = useState();
    const [questionMatchThree, setQuestionMatchThree] = useState();

    const dummy = useRef();



    useEffect(() => {
      handleListen()
    }, [isListening])
  
    const handleListen = () => {
  
      if (isListening) {
        mic.start()
        mic.onend = () => {
          console.log('continue..')
          mic.start()
        }
      } else {
        mic.stop()
        mic.onend = () => {
          console.log('Stopped Mic on Click')
          //handleSaveNote();
        }
      }
      mic.onstart = () => {
        console.log('Mics on')
      }
  
      mic.onresult = event => {
  
        const transcript = Array.from(event.results)
          .map(result => result[0])
          .map(result => result.transcript)
          .join('')
        //console.log(transcript)
        const sOne = transcript
      const punctuationlessOne = sOne.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"");
      const questionmarklessOne = punctuationlessOne.replace(/\s{2,}/g," ");
      const stringOne = questionmarklessOne.replace('?', '');
      const strOne = stringOne.toUpperCase();
      const testnote = strOne.replace(/\s/g, '');
      const testnotetwo = testnote.normalize("NFD").replace(/[\u0300-\u036f¿]/g, "")
      const finalNote = testnotetwo.replace(/'/g, '');
      
      setTranscriptDisplay(transcript);
      setNote(`${finalNote}`);
        
        mic.onerror = event => {
          console.log(event.error)
        }
      }
    };


    const FailedModal = () => {

      const handleBackToLevels = () => {
        history.push('/levels')
      };

      const handleReTry = () => {
        document.location.reload() 
      };
    
      return (
        <> 
        <Modal show={showTwo}>
        <Modal.Header>{"Opps!"}</Modal.Header>
            <Modal.Body>{'you ran out of attempts, better luck next time, try again?'}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => handleBackToLevels()}>
                Return To Levels
              </Button>
              <Button variant="secondary" onClick={()=> handleReTry()}>
                Try Again
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
  
      };



    const Speech = (props) => {

      const msg = new SpeechSynthesisUtterance();
      const voices = speechSynthesis.getVoices();
      msg.text = `${props}`;
      msg.rate = 0.85;
      msg.pitch = 0.99;
      msg.voice = voices.find((voice) => voice.lang === `${storageLanguage}`);
      msg.lang = storageLanguage;

      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(msg);
    
    };






    //Gets all the questions.....

    const getUsers = async () => {
        const data = await getDocs(messagesRef);
        setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setQuestion(users[0]);
        setLoading(false);

      };
    
    
      useEffect(() => {
    
        setLoading(true);
    
        getUsers();      
        
      }, []);



      useEffect(() => {

        if (timeLeft===0){
            
          if (lives === 3) {
            setTimeLeft(100);
            SetLives(lives - 1);
          } else if (lives === 2) {
            setTimeLeft(100);
            SetLives(lives - 1);
          } else if (lives === 1) {
            setTimeLeft(100);
            SetLives(lives - 1);
          } else if (lives === 0) {
            handleShowTwo();

          } else {
            handleShowTwo();
          }
        }
    
        // exit early when we reach 0
        if (!timeLeft) return;
    
        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
    
          setTimeLeft(timeLeft - 2);
    
        }, 500);
    
        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    
      }, [timeLeft]);





      //ONCE THE PERSON STARTS GUESSING THE BELOW STARTS...
      const clickDown = (props) => {

        //STARTS LISTENING FOR THEIR VOICE...
        setIsListening(prevState => !prevState); 

        console.log(props)
        
        if(props === undefined) {

          return null;

        } else {

          //GETS JUST/JOINS THE LETTERS FORM THE GUESSING RESPONSE...

          const s = props;
          const punctuationless = s.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'"]/g,"");
          const questionmarkless = punctuationless.replace(/\s{2,}/g," ");
          const string = questionmarkless.replace('?', '');
          const str = string.toUpperCase();
          const testnotetwo = str.replace(/\s/g, '');
          const testnotetwothree = testnotetwo.normalize("NFD").replace(/[\u0300-\u036f¿]/g, "")
          const finalString = testnotetwothree.replace("'", '');

          setPhasedInput(finalString);

        };
    
      };



      //ONCE THE PERSON IS DONE GUESSING THE BELOW STARTS...
      const clickUp = async (...params) => {

        //STARTS LISTENING FOR THEIR VOICE...
        setIsListening(prevState => !prevState);

        //THIS COMPARES HOW ACCURATE THEY WERE...
        /*function Compare(strA,strB){
          for(var result = 0, i = strA.length; i--;){
              if(typeof strB[i] == 'undefined' || strA[i] == strB[i]);
              else if(strA[i].toLowerCase() == strB[i].toLowerCase())
                  result++;
              else
                  result += 4;
          }
         // console.log(1 - (result + 4*Math.abs(strA.length - strB.length))/(2*(strA.length+strB.length)));
      }

      //IT WILL ALWAYS BE LESS THAN 1 BUT COULD BE COMPARED FOR 0.7+ TO PASS THE QUESTION 'LEVEL' ETC...
      Compare(`${note}`, `${phasedInput}`)*/

          // IF THEY GET THE AWNSER RIGHT THE BELOW MOVES THE COUNTER TO THE NEXT QUESTION....
          console.log(note)
          console.log(phasedInput)

        if (note === phasedInput) {

          setTimeLeft(null);

          console.log(params)

              if (params[1] === 0) {

                conversation.push(`You: ${params[0]}`);

                handleShowOne();

                if (localStorage.getItem("levelCount") > localStorage.getItem("selectedLevel")){

                  return null;

                } else {

                  localStorage.setItem('levelCount', +localStorage.getItem("levelCount") + 1);
                };

              } else {

                if (params[1] === 0) {

                  handleShowOne();
  
                } else {

                  conversation.push(`You: ${params[0]}`);
                  
                  setQuestionKey(params[1]);
  
              anotherFuckingFunction();
  
            //  console.log(params[1])
  
              setDiplayTranslationOne(false);
              setDiplayTranslationTwo(false);
              setDiplayTranslationThree(false);
  
              setDiplaySpeechButtonThree(false);
              setDiplaySpeechButtonTwo(false);
              setDiplaySpeechButtonOne(false);
  
              setMainQuestionSwitch(false);
  
              setSuccess(true);
              SetLives(3);

              setTimeLeft(100);
              setQuestionMatchBoolan(false)              

                }
              
              }
  
        } else if (note === null || note === undefined || note === '') {

          //IF THE FIELD IS EMPTY THEN WE DON'T TAKE ANY LIVES/GIVE CLUES...
          setSuccess(null);
          setTimeLeft(timeLeft);

        } else {

          //IF THE PERSON GETS THE GUESS WRONG IT STARTS THE BELOW, EACH WRONG ANWSER TAKES A LIFE AWAY BUT GIVES A CLUE...

            if (params[0] === originalOne){

              if (lives === 3) {

                setMainQuestionSwitch(true);
                SetLives(lives - 1);
                setSuccess(false);
                setTimeLeft(100);


              } else if (lives === 2) {

                setDiplayTranslationOne(true);
                SetLives(lives - 1);
                setDiplaySpeechButtonOne(true);
                setTimeLeft(100);

              

              } else if (lives === 1) {

                SetLives(lives - 1);
                setTimeLeft(100);

              } else {

                handleShowTwo();
                setTimeLeft(0);

                
              };
    
            } else if (params[0] === originalTwo){

              if (lives === 3) {

                setMainQuestionSwitch(true);
                SetLives(lives - 1);
                setSuccess(false);
                setTimeLeft(100);


              } else if (lives === 2) {

                setDiplayTranslationTwo(true);
                SetLives(lives - 1);
                setDiplaySpeechButtonTwo(true);
                setTimeLeft(100);

              

              } else if (lives === 1) {

                SetLives(lives - 1);
                setTimeLeft(100);

              } else {

                handleShowTwo();
                setTimeLeft(0);

                
              };
    
            } else if (params[0] === originalThree){

              if (lives === 3) {

                setMainQuestionSwitch(true);
                SetLives(lives - 1);
                setSuccess(false);
                setTimeLeft(100);


              } else if (lives === 2) {

                setDiplayTranslationThree(true);
                SetLives(lives - 1);
                setDiplaySpeechButtonThree(true);
                setTimeLeft(100);

              

              } else if (lives === 1) {

                SetLives(lives - 1);
                setTimeLeft(100);

              } else {

                handleShowTwo();
                
                setTimeLeft(0);

                
              };
    
            } else {

              return null;

            };

        };

   };



      // THIS ALLOWS FOR THE CLUES TO BE PROVIDED TO THE FIRST RESPONSE...
      const FirstDisplayTranslation = () => {

        if (diplayTranslationOne === false && diplaySpeechButtonOne == false) {
          
          return null
    
        } else if (diplayTranslationOne === true  && diplaySpeechButtonOne == false) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedOne}</h5>
              </div>
          );
    
        } else if (diplayTranslationOne === true  && diplaySpeechButtonOne == true) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedOne}</h5>
                <Button variant="secondary" onClick={()=> Speech(translatedOne)}>Speech</Button>
              </div>
          );
    
        } else if (diplayTranslationOne === false  && diplaySpeechButtonOne == true) {
    
          return (
              <div>
                <h3>test</h3>
              </div>
          );
    
        } 
      
      };



      // THIS ALLOWS FOR THE CLUES TO BE PROVIDED TO THE SECOND RESPONSE...
      const SecondDisplayTranslation = () => {

        if (diplayTranslationTwo === false && diplaySpeechButtonTwo == false) {
          
          return null
    
        } else if (diplayTranslationTwo === true  && diplaySpeechButtonTwo == false) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedTwo}</h5>
              </div>
          );
    
        } else if (diplayTranslationTwo === true  && diplaySpeechButtonTwo == true) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedTwo}</h5>
                <Button variant="secondary" onClick={()=> Speech(translatedTwo)}>Speech</Button>
              </div>
          );
    
        } else if (diplayTranslationTwo === false  && diplaySpeechButtonTwo == true) {
    
          return (
              <div>
                <h3>test</h3>
              </div>
          );
    
        } 
      
      };


      // THIS ALLOWS FOR THE CLUES TO BE PROVIDED TO THE THRID RESPONSE...
      const ThirdDisplayTranslation = () => {

        if (diplayTranslationThree === false && diplaySpeechButtonThree == false) {
          
          return null
    
        } else if (diplayTranslationThree === true  && diplaySpeechButtonThree == false) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedThree}</h5>
              </div>
          );
    
        } else if (diplayTranslationThree === true  && diplaySpeechButtonThree == true) {
    
          return (
              <div>
                <h5 style={{color: 'grey'}}>{translatedThree}</h5>
                <Button variant="secondary" onClick={()=> Speech(translatedThree)}>Speech</Button>
              </div>
          );
    
        } else if (diplayTranslationThree === false  && diplaySpeechButtonThree == true) {
    
          return (
              <div>
                <h3>test</h3>
              </div>
          );
    
        } 
      
      };




      // THIS ALLOWS FOR THE QUESTION TO BE SHOWN IN THE LEARNING LANGUAGE...
      const MainQuestion = (translatedQuestion, originalQuestion) => {

        if (displaySpinner === true) {
          return (

            <div>
              <center>
              <Spinner animation="border" role="status">
              
              <span className="visually-hidden">Loading...</span>
              
              </Spinner>
              </center>
            </div>
            
            )
        } else {

          if (questionMatchBoolan === false) {
            return (
              <div>
                <h5>Pick which you think they're saying?</h5>
              </div>
                
            );
          } else {

            if (MainQuestionSwitch === false) {
          
              return (
                <div>
                  <h5 onMouseOver={()=>{console.log('test')}}>{translatedQuestion}</h5>
                </div>
                  
              );
        
            } else if (MainQuestionSwitch === true) {
        
              return (
                  <div>
                    <h5>{translatedQuestion}</h5>
                    <h5 style={{color: 'grey'}}>{originalQuestion}</h5>
                  </div>
              );
        
            } else {
        
              return null;
        
            };

          };

        }
      
      };



      //if an awnswer is wrong or right this notifies the person...
      const AlertDismissable = () => {

        if (success === true) {
          
          return (
            <div>
              <h6 style={{ color: 'green' }}>
                Correct, well done!
              </h6>
    
            </div>
              
              
          );
    
        } else if (success === false) {
    
          return (
              <h6 style={{color: 'red'}}>wrong, try again!</h6>
          );
    
        } else {
    
          return null;
    
        };
      
      };

      const anotherFuckingFunction = async (props) => {

        setDisplaySpinner(true)

      try {

      setQuestionMatchOne(users[props].questionMatchOne)

      setQuestionMatchTwo(users[props].questionMatchTwo)
      setQuestionMatchThree(users[props].questionMatchThree)

      setOriginalOne(users[props].responseOne[1]);
      setOriginalOneNextQuestion(users[props].responseOne[0]);

      setOriginalTwo(users[props].responseTwo[1]);
      setOriginalTwoNextQuestion(users[props].responseTwo[0]);

      setOriginalThree(users[props].responseThree[1]);
      setOriginalThreeNextQuestion(users[props].responseThree[0]);

      setOriginalQuestion(users[props].question);

      } catch (error) {

        console.log(error);
        
      } finally {

      if (storageLanguage === 'es-ES'){

        await axios.post(`${process.env.REACT_APP_FIREBASE_BACKEND}/test`, {
          one: users[props].responseOne[1],
          two: users[props].responseTwo[1],
          three: users[props].responseThree[1],
          question: users[props].question,
          language: 'es'
      })
      .then(function (response) {
        setDisplaySpinner(false)
        setTranslatedOne(response.data.a);
        setTranslatedTwo(response.data.b);
        setTranslatedThree(response.data.c);
        setTranslatedQuestion(response.data.d); 
        Speech(response.data.d)  

      })
      .catch(function (error) {
        console.log(error);
      });

      } else if (storageLanguage === 'it-IT'){

        await axios.post(`${process.env.REACT_APP_FIREBASE_BACKEND}/test`, {
          one: users[props].responseOne[1],
          two: users[props].responseTwo[1],
          three: users[props].responseThree[1],
          question: users[props].question,
          language: 'it'
      })
      .then(function (response) {
        setDisplaySpinner(false)
        setTranslatedOne(response.data.a);
        setTranslatedTwo(response.data.b);
        setTranslatedThree(response.data.c);
        setTranslatedQuestion(response.data.d); 
        Speech(response.data.d)  

      })
      .catch(function (error) {
        console.log(error);
      });

      } else if (storageLanguage === 'fr-FR'){

        await axios.post(`${process.env.REACT_APP_FIREBASE_BACKEND}/test`, {
          one: users[props].responseOne[1],
          two: users[props].responseTwo[1],
          three: users[props].responseThree[1],
          question: users[props].question,
          language: 'fr'
      })
      .then(function (response) {
        setDisplaySpinner(false)
        setTranslatedOne(response.data.a);
        setTranslatedTwo(response.data.b);
        setTranslatedThree(response.data.c);
        setTranslatedQuestion(response.data.d); 
        Speech(response.data.d)  

      })
      .catch(function (error) {
        console.log(error);
      });

      } else if (storageLanguage === 'ro-RO'){

        await axios.post(`${process.env.REACT_APP_FIREBASE_BACKEND}/test`, {
          one: users[props].responseOne[1],
          two: users[props].responseTwo[1],
          three: users[props].responseThree[1],
          question: users[props].question,
          language: 'ro'
      })
      .then(function (response) {
        setDisplaySpinner(false)
        setTranslatedOne(response.data.a);
        setTranslatedTwo(response.data.b);
        setTranslatedThree(response.data.c);
        setTranslatedQuestion(response.data.d); 
        Speech(response.data.d)  

      })
      .catch(function (error) {
        console.log(error);
      });

      } else {

        return null;

      };
        
      }

      };



      useEffect(() => {

        anotherFuckingFunction(questionKey);

      }, [users, questionKey]);


      


      const LivesCount = () => {

        if (lives === 0) {

          return (
              <h6 style={{color: 'red'}}>Final attempt!</h6>
          );

        } else if (lives === 3) {

          return null;

        } else {

          return (
            
           <h6 style={{color: 'red'}}>You've got {lives + 1} attempts!</h6>
       
          );

        };

      };

      function OffCanvas(props) {
        
      
        return (
          <>
            <Button style={{backgroundColor: '#F239DF', color: "white", border: 'none'}} onClick={handleShowTab} >Rules</Button>
            <Offcanvas show={showTab} onHide={handleCloseTab} {...props}>
            <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
              <Offcanvas.Body>
              <>
                <center>
                <img  style={{ height: '80px'}} src={logo} />
                <br/>
                <br/>
                <br/>
                </center>
                <h5>Simple. Get to the end of the conversation!</h5><br/>
                <h6>1. This is a 'choose your own ending' conversation. each response results in a different routes the conversation leads.</h6><br/>
                <h6>2. The attempted response (1 of the three options) should be said out loud in the language you specified your learning.</h6><br/>
                <h6>3. You recieve 3 attempts per response, try all three or recieve specific hints if you attempt the same response more than once.</h6><br/>
                <h6>4. If the countdown bar hits 0 it reduces the ammount of attempts you get by 1.</h6><br/>        
                </>
                

             </Offcanvas.Body>
            </Offcanvas>
          </>
        );
      }





      const PassedModal = () => {

        const handleBackToLevels = () => {
          history.push('/levels')
        };
  
        const handleReTry = () => {
          document.location.reload() 
        };
      
        return (
          <> 
          <Modal show={showOne}>
            <Modal.Header>Congratulations!</Modal.Header>
              <Modal.Body>
                {'You passed the level, why not try again and navigate another route of the conversation.'}<br/><br/>
                <h4>Dialog Transcript</h4><br/>
                {convoLoop()}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => handleBackToLevels()}>
                  Return To Levels
                </Button>
                <Button variant="secondary" onClick={()=> handleReTry()}>
                  Try Again
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
    
        };


        const questionMatching = (props) => {

          if (props === originalQuestion) {

            setQuestionMatchBoolan(true);
            setSuccess(true);
            SetLives(3);
            setNote('')
            setTranscriptDisplay('Click and hold one of the below to attempt to respond.')
            conversation.push(`Them: ${originalQuestion}`);

          } else {

            if (lives === 0 ) {

              handleShowTwo();

            } else {

            setSuccess(false);
            const msg = new SpeechSynthesisUtterance();
            const voices = speechSynthesis.getVoices();
            msg.text = `${translatedQuestion}`;
            msg.rate = 0.04;
            msg.pitch = 0.9;
            msg.voice = voices.find((voice) => voice.lang === `${storageLanguage}`);
            msg.lang = storageLanguage;
            
            window.speechSynthesis.cancel();
            window.speechSynthesis.speak(msg);

            SetLives(lives - 1);

            }

          }

        };



        const Insert = () => {

          if (questionMatchBoolan === false) {
  
            return (
              <div>
              <Row>
                <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} onClick={()=>{questionMatching(questionMatchOne)}} data-aos="fade-up" data-aos-duration="1500">
                  <Card.Body>
                    <h3 style={{color: 'white'}}>{questionMatchOne}</h3>
                  </Card.Body>
                </Card>
                <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} onClick={()=>{questionMatching(questionMatchTwo)}} data-aos="fade-up" data-aos-duration="1500">
                  <Card.Body>
                    <h3>{questionMatchTwo}</h3>
                  </Card.Body>
                </Card>
                <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} onClick={()=>{questionMatching(questionMatchThree)}} data-aos="fade-up" data-aos-duration="1500">
                  <Card.Body>
                    <h3 style={{color: 'white'}}>{questionMatchThree}</h3>
                  </Card.Body>
                </Card>
              </Row>
              <div data-aos="fade-up" data-aos-duration="1500">
              <AlertDismissable />
              </div>
              </div>
  
            );
  
          } else if (questionMatchBoolan === true){
  
            return (
              
              <div>
                <center>
              <Row  style={{margin: '3%'}}>
              <h3 style={{color: 'white'}}>{transcriptDisplay}</h3>
              </Row>
            </center>
              <center>
                <Row  style={{maxWidth: "60%"}}>
                  <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} data-aos="fade-up" data-aos-duration="1500" onMouseDown={()=> clickDown(translatedOne)} onMouseUp={()=> clickUp(originalOne, originalOneNextQuestion)}>
                      <Card.Body >
                          <Card.Text>
                              <h3>{originalOne}</h3>
                              {FirstDisplayTranslation()}
                          </Card.Text>
                      </Card.Body>
                  </Card>
          
                  <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} data-aos="fade-up" data-aos-duration="1500" onMouseDown={()=> clickDown(translatedTwo)} onMouseUp={()=> clickUp(originalTwo, originalTwoNextQuestion)} >
                      <Card.Body>
                          <Card.Text>
                          <h3>{originalTwo}</h3>
                          {SecondDisplayTranslation()}
                          </Card.Text>
                      </Card.Body>
                  </Card>
                
                  <Card style={{marginBottom: "4%", backgroundColor: '#1D1D41', color: 'white', cursor: "pointer"}} data-aos="fade-up" data-aos-duration="1500" onMouseDown={()=> clickDown(translatedThree)} onMouseUp={()=> clickUp(originalThree, originalThreeNextQuestion)}>
                      <Card.Body>
                          <Card.Text>
                          <h3>{originalThree}</h3>
                          {ThirdDisplayTranslation()}
                          </Card.Text>
                      </Card.Body>
                  </Card>
  
                </Row>
              </center>
              <div data-aos="fade-up" data-aos-duration="1500">
              <AlertDismissable />
              </div>
              <center>
            <br/>
            {<center data-aos="fade-up" data-aos-duration="1500"><Button style={isListening ? {backgroundColor: 'red', color: "white", border: 'none', borderRadius: '100%', height: '65px', width: '65px'}:{backgroundColor: '#C3C3C3', color: "white", border: 'none', borderRadius: '100%', height: '65px', width: '65px'}} size="lg"><AiFillAudio/></Button></center> }
            </center>
              </div> 
            );
  
          };
  
      };


      const convoLoop = () => {

        return conversation.map((sentence, i) => {
            return (
                <div key = {i} >
                    <h6 style={{ color: 'black' }}>{sentence}</h6>
                    <span ref={dummy}></span>
                </div>
            )
        })

    };





      

    
      const rendered = () => {

          return (
            <div style={{backgroundColor: "#141332", overflow: 'hidden'}}>
            <div style={{backgroundColor: "#141332", marginLeft: '5%', marginRight: '5%'}}>
              {FailedModal()}
              {PassedModal()}
              <Row>
            <Col>
            <Link to="/levels"><ArrowBackIosIcon style={{margin: '5%', color: 'white'}}/></Link>
            </Col>
            <Col>
            <center>
              <ProgressBar variant="danger" now={timeLeft} style={{maxWidth: '100%', marginTop: '7%'}}/>
              </center>
            </Col>
            <Col>
            <h3 style={{color: "white", margin: '5%', textAlign: 'right', fontWeight: '900'}}>Talk Toco</h3>
            </Col>

          </Row>
            <div style={{padding: '1%', marginBottom: '5%'}}>
              <Row >
                <center>
                {LivesCount()}
                </center>
              </Row>
              <center>
              <Row  style={{marginTop: '2%', color: 'grey'}}>
              {MainQuestion(translatedQuestion, originalQuestion)}
              </Row>
            </center>
            <center>
              <Row>
              </Row>
              <Row  style={{maxWidth: "60%"}}>
                {Insert()}
              </Row>
            </center>
            </div>
            </div> 
            <Footer/>
            </div>
          );

    };






      if (localStorage.getItem("level") === null) {

        return (
          <div style={{padding: '13%', overflow: 'hidden'}}>
            <center>
              <h1 style={{color: '#322C2C'}}>Please head to our home to specify a level.</h1>
              <Link to="/"><Button style={{backgroundColor: '#5208F0', color: "white", border: 'none', marginTop: '5%'}} size="lg">return</Button></Link>
            </center>
          </div>
        );

      } else if (localStorage.getItem("language") === null) {

        return (
          <div style={{padding: '13%', overflow: 'hidden'}}>
            <center>
              <h1 style={{color: '#322C2C'}}>Please head to our home to specify a language.</h1>
              <Link to="/"><Button style={{backgroundColor: '#5208F0', color: "white", border: 'none', marginTop: '5%'}} size="lg">return</Button></Link>
            </center>
          </div>
        );

      } else if(localStorage.getItem("levelCount") === null){

        return (
          <div style={{padding: '13%', overflow: 'hidden'}}>
            <center>
              <h1 style={{color: '#322C2C'}}>Please head to our home to specify a level.</h1>
              <Link to="/"><Button style={{backgroundColor: '#5208F0', color: "white", border: 'none', marginTop: '5%'}} size="lg">return</Button></Link>
            </center>
          </div>
        );

      } else if(localStorage.getItem("selectedLevel") === null){

        return (
          <div style={{padding: '13%', overflow: 'hidden'}}>
            <center>
              <h1 style={{color: '#322C2C'}}>Please head to our home to specify a level.</h1>
              <Link to="/"><Button style={{backgroundColor: '#5208F0', color: "white", border: 'none', marginTop: '5%'}} size="lg">return</Button></Link>
            </center>
          </div>
        );

      } else {

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    
          return (
            <div>
              <h1>Currently our platform is still in BETA and doesn't support mobile devices. Please use our platform on a desktop or PC. Apologies for the inconvenience, we're looking into this.</h1>
            </div>
          );
      
         } else {

        return (
          <div>
      
           {loading ? <center><Spinner animation="border" role="status">
      
      <span className="visually-hidden">Loading...</span>
      
      </Spinner></center> : rendered() }
      
          </div>
        );

         }

      };

}

export default ListedQuestion;

